import { r2PaletteColors } from '../layout/themes'

const transactionTypes = () => [
    { id: "DISBURSEMENT", name: "resources.Transaction.types.disbursement", color: r2PaletteColors.green },
    { id: "REPAYMENT", name: "resources.Transaction.types.repayment", color: r2PaletteColors.blue },
    { id: "CHARGEBACK", name: "resources.Transaction.types.chargeback", color: r2PaletteColors.orange },
    { id: "ADJUSTMENT", name: "resources.Transaction.types.adjustment", color: r2PaletteColors.purple },
    { id: "DIRECT_PAYMENT", name: "resources.Transaction.types.directPayment", color: r2PaletteColors.purple },

]


export const defaultTransactionType = { id: "DEFAULT", name: "resources.Transaction.types.default", color: r2PaletteColors.blue }

export default transactionTypes